import React, { useEffect } from "react";
import { useActiveGenre } from "../../utils/Genre/activeGenreState";
import FooterMeta from "./components/FooterMeta";
import FooterMedia from "./components/FooterMedia";

export default function Footer({ type }) {
  const [activeGenre] = useActiveGenre();
  if (!activeGenre) return;
  return (
    <div
      className="page-sink"
      style={{
        backgroundColor: type === "home" ? "rgba(0,0,0,.33)" : "rgba(0,0,0,1)",
        backgroundImage:
          type === "genre" && activeGenre
            ? `linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(${activeGenre?.theme?.colors?.dark?.rgb}, 1) 100%)`
            : type === "page"
              ? `linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(229, 9, 20, 1) 100%)`
              : `none`,
      }}
    >
      {type !== "home" && (
        <div className="page-sink-background" aria-hidden={"true"} />
      )}
      <div className="width-ctrl">
        <div
          className={
            "page-sink-grid flex-column-reverse flex-lg-row " +
            (type === "genre" && activeGenre && "gap-4")
          }
        >
          <FooterMeta />
          {type === "genre" && activeGenre && (
            <FooterMedia activeGenre={activeGenre} />
          )}
        </div>
      </div>
    </div>
  );
}
